import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isDateTime, isCode, isCheckbox } from 'src/types/columnFlags';
const controlledActions = {
    create: [-1],
    fetch: [312],
    update: [-1],
    delete: [-1],
    downloadList: [312],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'id', style: 'width:50px', isNumeric: true },
        { name: 'requested_at', style: 'width:150px', isDateTime },
        { name: 'user_name' },
        { name: 'api_endpoint' },
        { name: 'request_payload', style: 'min-width: 200px', isCode, codeLanguage: 'JSON' },
        { name: 'response', isCode, codeLanguage: 'JSON' },
        { name: 'is_outgoing_request', isCheckbox, uiFilterTypes: ['selectedValuesFilter'] },
        { name: 'status' },
        { name: 'details', isCode, codeLanguage: 'JSON' }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'ci.api_log',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'API log'
});
export default localEntity;
